import { render } from "./FlagRU.vue?vue&type=template&id=69e3b1c1"
import script from "./FlagRU.vue?vue&type=script&lang=js"
export * from "./FlagRU.vue?vue&type=script&lang=js"

import exportComponent from "/vhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__